// ── CSV parsing ─────────────────────────────────────────────────────────────
//
// Hand-rolled rather than a dependency, and it has to stay that way: it feeds
// the component import, where a mis-parsed row writes wrong prices and stock
// figures without anything failing.
//
// Quirks worth knowing, all of them deliberate and all relied on by the import:
//   * every field is trimmed
//   * rows where every field is empty are dropped
//   * a bare CR is data, not a line break - only LF and CRLF end a row
//   * a quote inside an unquoted field opens a quoted section mid-field

/**
 * Parse CSV text into rows of trimmed fields.
 *
 * Handles quoted fields, embedded commas and newlines, and doubled quotes as
 * an escaped quote.
 */
export function parseCSV(text: string): string[][] {
  const rows: string[][] = [];
  let current = '';
  let inQuotes = false;
  let row: string[] = [];

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"' && text[i + 1] === '"') {
        current += '"';
        i++;
      } else if (ch === '"') {
        inQuotes = false;
      } else {
        current += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ',') {
        row.push(current.trim());
        current = '';
      } else if (ch === '\n' || (ch === '\r' && text[i + 1] === '\n')) {
        row.push(current.trim());
        current = '';
        if (row.some((c) => c !== '')) rows.push(row);
        row = [];
        if (ch === '\r') i++;
      } else {
        current += ch;
      }
    }
  }

  // Trailing row with no line break after it.
  if (current || row.length > 0) {
    row.push(current.trim());
    if (row.some((c) => c !== '')) rows.push(row);
  }

  return rows;
}
